"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_PERSONAL_SETTING = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("..");
const auth_1 = require("common/auth");
const react_bootstrap_1 = require("react-bootstrap");
const auth_2 = require("firebase/auth");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const schemaComponents_1 = require("@/schemaComponents");
const components_1 = require("utils/components");
const auth = (0, auth_2.getAuth)(firebase_app_1.default);
exports.UPDATE_PERSONAL_SETTING = __1.PERSONAL_SETTING.sub("/edit", PersonalSetting);
// export const ADD_PROJECT = PROJECTS.sub("/edit/new", Project);
function PersonalSetting() {
    (0, auth_1.useUserPageAuthorization)();
    // 現在有効な sign-in method を取得
    const [signInMethods, setSignInMethods] = react_1.default.useState();
    const [signInMethodRefresher, setSignInMethodRefresher] = react_1.default.useState({});
    (0, react_1.useEffect)(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const signInMethods = yield (0, auth_2.fetchSignInMethodsForEmail)(auth, ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "");
            setSignInMethods(new Set(signInMethods));
        }))().catch(console.error);
    }, [signInMethodRefresher]);
    // const [personalData, setPersonalData] = useLocalStorage("personalData", {
    //   ignoreExactMatchedReference: false,
    // });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.PageHeader, { title: "個人設定" }),
        react_1.default.createElement("div", { style: { padding: "10px" } },
            react_1.default.createElement(schemaComponents_1.SchemaInput
            // onValueChange={(value) => {
            //   setPersonalData(value);
            // }}
            // data={personalData}
            , { 
                // onValueChange={(value) => {
                //   setPersonalData(value);
                // }}
                // data={personalData}
                data: {}, schema: {
                    schemaType: "object",
                    properties: [
                        // {
                        //   propertyName: "ignoreExactMatchedReference",
                        //   title: "完全一致する参照訳を無視する",
                        //   tooltip:
                        //     "翻訳時に、完全一致する参照訳がある場合、通常はその訳が採用されますが、これだと翻訳の評価がしづらくなります。オンにすると完全一致する参照訳を無視して、それ以外の訳をもとに翻訳を行います。この設定は、ブラウザごとに保存されるため、異なるブラウザには反映されません。",
                        //   schema: {
                        //     schemaType: "boolean",
                        //   },
                        // },
                        {
                            propertyId: "google.com",
                            title: "Googleアカウント",
                            schema: {
                                schemaType: "message",
                                text: () => {
                                    if (!signInMethods || !auth.currentUser)
                                        return react_1.default.createElement(react_1.default.Fragment, null);
                                    if (signInMethods.has("google.com")) {
                                        return (react_1.default.createElement("span", null,
                                            react_1.default.createElement("span", null, "\u9023\u643A\u3057\u3066\u3044\u307E\u3059"),
                                            "\u00A0\u00A0",
                                            react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => __awaiter(this, void 0, void 0, function* () {
                                                    if (!auth.currentUser)
                                                        return;
                                                    yield (0, auth_2.unlink)(auth.currentUser, "google.com");
                                                    setSignInMethodRefresher({});
                                                }), variant: "warning" }, "\u89E3\u9664\u3059\u308B")));
                                    }
                                    else {
                                        return (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("span", null,
                                                react_1.default.createElement("span", null, "\u9023\u643A\u3057\u3066\u3044\u307E\u305B\u3093"),
                                                "\u00A0\u00A0",
                                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => __awaiter(this, void 0, void 0, function* () {
                                                        if (!auth.currentUser)
                                                            return;
                                                        yield (0, auth_2.linkWithPopup)(auth.currentUser, new auth_2.GoogleAuthProvider());
                                                        setSignInMethodRefresher({});
                                                    }) }, "\u9023\u643A\u3059\u308B"))));
                                    }
                                },
                            },
                        },
                        {
                            propertyId: "microsoft.com",
                            title: "Microsoftアカウント",
                            schema: {
                                schemaType: "message",
                                text: () => {
                                    if (!signInMethods || !auth.currentUser)
                                        return react_1.default.createElement(react_1.default.Fragment, null);
                                    if (signInMethods.has("microsoft.com")) {
                                        return (react_1.default.createElement("span", null,
                                            react_1.default.createElement("span", null, "\u9023\u643A\u3057\u3066\u3044\u307E\u3059"),
                                            "\u00A0\u00A0",
                                            react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => __awaiter(this, void 0, void 0, function* () {
                                                    if (!auth.currentUser)
                                                        return;
                                                    yield (0, auth_2.unlink)(auth.currentUser, "microsoft.com");
                                                    setSignInMethodRefresher({});
                                                }), variant: "warning" }, "\u89E3\u9664\u3059\u308B")));
                                    }
                                    else {
                                        return (react_1.default.createElement("span", null,
                                            react_1.default.createElement("span", null, "\u9023\u643A\u3057\u3066\u3044\u307E\u305B\u3093"),
                                            react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => __awaiter(this, void 0, void 0, function* () {
                                                    if (!auth.currentUser)
                                                        return;
                                                    yield (0, auth_2.linkWithPopup)(auth.currentUser, new auth_2.OAuthProvider("microsoft.com"));
                                                    setSignInMethodRefresher({});
                                                }), variant: "secondary" }, "\u9023\u643A\u3059\u308B")));
                                    }
                                },
                            },
                        },
                    ],
                } }))));
}
exports.default = PersonalSetting;
